module.exports = __webpack_public_path__ + "img/China.b1cb24cc.svg";